// src/services/rfidService.js
import Vue from "vue";
import {EventBus} from '@/eventBus';

class RFIDService {
	constructor() {
		// RFID-related state
		this.ndef = null;
		this.abortController = null;
		this.isConnected = false;
		this._onReading = this.onRfidRead.bind(this);
		this._onReadingError = this.onReadingErrorHandler.bind(this);

		// Initialize event bus for emitting RFID events
		this.eventBus = EventBus || new Vue();
	}

	doesDeviceHaveNFC() {
		try {
			return "NDEFReader" in window && typeof NDEFReader !== 'undefined';
		} catch {
			return false;
		}
	}

	// Initialize RFID reader (example)
	async connectReader() {
		try {
			if (!this.doesDeviceHaveNFC()) {
				alert("This device does not support NFC. Please use Chrome on an Android Device.");
				return
			}

			if (this.isConnected) {
				alert("RFID reader already connected");
				return
			}

			this.abortController = new AbortController();
			this.ndef = new NDEFReader();

			this.ndef.addEventListener("reading", this._onReading);
			this.ndef.addEventListener("readingerror", this._onReadingError);

			await this.ndef.scan({signal: this.abortController.signal});
			this.isConnected = true;
			this.eventBus.$emit(`rfid:connected`);
		} catch (error) {
			this.isConnected = false;
			alert('Cannot read data from the RFID. Try again or return it to your Gate Supervisor or Champion.');
		}
	}

	onReadingErrorHandler() {
		alert('Cannot read data from the RFID. Try again or return it to your Gate Supervisor or Champion.');
	}

	// Called when an RFID is read successfully
	// RFID is emitted as a Low to High 7 byte Hex string (14 chars) with the colons stripped.
	onRfidRead({serialNumber}) {
		// Strip colons
		const rfid = serialNumber.replace(/:/g, '');

		this.eventBus.$emit(`rfid:scanned`, {rfid: rfid});
	}

	disconnectReader() {
		this.isConnected = false
		if (this.abortController) {
			this.abortController.abort()
			this.abortController = null
		}
		if (this.ndef) {
			this.ndef.removeEventListener("reading", this._onReading);
			this.ndef.removeEventListener("readingerror", this._onReadingError);
			this.ndef = null
		}
	}

	// Subscribe to RFID events
	on(event, callback) {
		this.eventBus.$on(event, callback);
	}

	once(event, callback) {
		this.eventBus.$once(event, callback);
	}

	// Unsubscribe from RFID events
	off(event, callback) {
		this.eventBus.$off(event, callback);
	}
}

// Export singleton instance
const rfidService = new RFIDService();
export default rfidService;